import axios from 'axios';
import { API } from '../../config/api';
import { basicAuth } from '../../config/auth';

export const FETCH_DATA_REQUEST = 'FETCH_DATA_REQUEST';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE';

export const fetchUsersDataRequest = () => ({ type: FETCH_DATA_REQUEST });
export const fetchUsersDataSuccess = (data) => ({ type: FETCH_DATA_SUCCESS, payload: data });
export const fetchUsersDataFailure = (error) => ({ type: FETCH_DATA_FAILURE, payload: error });

export const fetchUsers = (params = {}) => {
  return async (dispatch) => {
    dispatch(fetchUsersDataRequest());
    try {

      const queryString = new URLSearchParams(params).toString();
      const response = await axios.get(`${API.auth.user}${queryString ? `?${queryString}` : ''}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Basic ${basicAuth}`,
        },
      });

      dispatch(fetchUsersDataSuccess(response.data.users));
    } catch (error) {
      console.error('Error fetching users:', error);
      dispatch(fetchUsersDataFailure(error.message));
    }
  };
};
